import { render, staticRenderFns } from "./selectInstitution1.vue?vue&type=template&id=ff311a4a&"
import script from "./selectInstitution1.vue?vue&type=script&lang=js&"
export * from "./selectInstitution1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports